module.exports = __webpack_public_path__ + "static/media/Group 1580.76d4e305.png";